/**
 * Vérifie si la valeur est un EAN (suite de 13 chiffres)
 */
export function valueIsEan(value: string): boolean {
  return /^\d{13}$/.test(value);
}
